const stepList = [
    { label: '开标准备', value: 'a' },
    { label: '投标文件开启', value: 'b' },
    { label: '唱标', value: 'c' },
    { label: '开标结束', value: 'd' },
]

const { getPurchaseTypeName } = require('./purchaseType')
const { getProjectTypeName } = require('./projectType')

const mixin = {
    methods: {
        getData() {
            this.$request
                .post(
                    '/transformToAfter/app/open/hall/kb/detail',
                    {
                        bdGuid: this.$route.query.id,
                    },
                    { showLoading: true },
                )
                .then((res) => {
                    this.data = {
                        'title': res.data.gcName,
                        'subTitle': res.data.bdName,
                        'code': res.data.bdBH,
                        'bidOpeningTime': res.data.afterTrialOpenBidTime || res.data.preTrialOpenBidTime,
                        'projectType': getProjectTypeName(res.data.xmLeiXing),
                        'status': '',
                        'jieMiTime': res.data.afterTrialEndTime || res.data.preTrialEndTime,
                        'fileCount': res.data.decryptNum,
                        'creator': res.data.projectManagerName,
                        'type': getPurchaseTypeName(res.data.zbFangShi),
                    }
                    console.log(this.data)
                })
        },
    },
}

module.exports = {
    stepList,
    mixin,
}
